module.exports = __webpack_public_path__ + "static/media/sr-1.8538e031.png";